import React, { useState } from "react";

import { useIsSurveyParticipant } from "hooks/queries/useIsAdmin";
import Header from "layout/Header";
import SideMenu from "layout/SideMenu";
import { classes } from "typestyle";

import styles, { sideMenuClass } from "./Layout.styles";

type LayoutProps = {
  children: React.ReactNode;
};

function Layout(props: LayoutProps) {
  const [isSideMenuOpen, setSideMenuOpen] = useState<boolean>(false);

  const { isSurveyParticipant } = useIsSurveyParticipant();

  const toggleSideMenuOpen = () => {
    setSideMenuOpen((prevState) => !prevState);
  };

  const closeSideMenu = () => {
    setSideMenuOpen(() => false);
  };

  const isSideMenuHidden = isSurveyParticipant;
  const isHeaderHidden = isSurveyParticipant;

  return (
    <div className={classes(!isSideMenuHidden && styles.sideMenuOverlay)}>
      {isSideMenuOpen && !isSideMenuHidden && (
        <div className={styles.backgroundFilter} onClick={closeSideMenu} />
      )}
      {!isSideMenuHidden && (
        <div className={sideMenuClass(isSideMenuOpen)}>
          <SideMenu
            isOpen={isSideMenuOpen}
            toggleMenu={toggleSideMenuOpen}
            closeMenu={closeSideMenu}
          />
        </div>
      )}
      <div
        className={classes(
          !isSideMenuHidden && styles.layoutContent,
          !isSideMenuOpen && !isSideMenuHidden && styles.layoutContentFull
        )}
      >
        <div className={classes(!isHeaderHidden && styles.pageContent)}>
          {!isHeaderHidden && <Header className={styles.header} />}
          <div className={styles.page}>{props.children}</div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
